import { Button } from "antd";
import type { ColumnsType } from "antd/es/table";

import { AppStrings } from "../../utils/constants/AppStrings";
import {
  formatDecimal,
  formatReportingTableDate,
} from "./reportingSummaryUtils";
import { formatCurrency } from "../../utils/financialFormatters";
import {
  ReportingSummaryMarginCell,
  ReportingSummaryPlCell,
} from "./ReportingSummaryTableCells";
import type {
  GetReportingSummaryColumnsOptions,
  ReportingSummaryRow,
} from "./reportingSummaryTypes";

export function getReportingSummaryColumns({
  onOpenProfitability,
  currencySymbol,
}: GetReportingSummaryColumnsOptions = {}): ColumnsType<ReportingSummaryRow> {
  const money = (v: number) => formatCurrency(v, currencySymbol, 2);

  return [
    {
      title: AppStrings.DATE,
      dataIndex: "date",
      key: "date",
      sorter: false,
      render: (
        d: ReportingSummaryRow["date"],
        record: ReportingSummaryRow,
      ) => {
        const label = formatReportingTableDate(d);
        return onOpenProfitability ? (
          <Button
            type="link"
            className="reporting-summary-date-cell"
            onClick={() => onOpenProfitability(record)}
          >
            {label}
          </Button>
        ) : (
          <span className="reporting-summary-date-cell">{label}</span>
        );
      },
    },
    {
      title: AppStrings.ACCEPTED_BETS,
      dataIndex: "acceptedBets",
      key: "acceptedBets",
      align: "center",
      sorter: true,
      render: (v: number) => formatDecimal(v, 0),
    },
    {
      title: AppStrings.REPORTING_ACCEPTED_TURNOVER,
      dataIndex: "acceptedTurnover",
      key: "acceptedTurnover",
      align: "center",
      sorter: true,
      render: (v: number) => money(v),
    },
    {
      title: AppStrings.REPORTING_AVG_STAKE,
      dataIndex: "avgStake",
      key: "avgStake",
      align: "center",
      sorter: true,
      render: (v: number) => money(v),
    },
    {
      title: AppStrings.REPORTING_PL_COLUMN,
      dataIndex: "pl",
      key: "pl",
      align: "center",
      sorter: true,
      render: (v: number) => (
        <ReportingSummaryPlCell value={v} currencySymbol={currencySymbol} />
      ),
    },
    {
      title: AppStrings.MARGIN,
      dataIndex: "margin",
      key: "margin",
      align: "center",
      sorter: true,
      render: (v: number) => <ReportingSummaryMarginCell value={v} />,
    },
  ];
}
